import { render, staticRenderFns } from "./UserEntity.vue?vue&type=template&id=492dbfb0&"
import script from "./UserEntity.vue?vue&type=script&lang=js&"
export * from "./UserEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports